<template>
  <div class="correct-plan section_">
    <correct-title title="计划信息" />
    <a-row class="plan-content">
      <a-col :xs="24" :md="12" :lg="8" v-for="item in fieldList" :key="item.key">
        <form-item :fieldItem="item" :editForm="plan" :formItemProp="'plan.' + item.key" :labelCol="labelCol" :wrapperCol="wrapperCol"></form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import correctTitle from './title';
import formItem from '../components/formItem/index.vue';
export default {
  name: 'plan',
  components: {
    correctTitle,
    formItem
  },
  inject: ['isMobile'],
  props: {
    plan: {
      type: Object,
      default: () => {}
    },
    planCfg: {
      type: Object,
      defaule: () => {}
    }
  },
  data() {
    return {
      labelCol: { xs: 8, sm: 6, md: 6, lg: 4, xl: 6 },
      wrapperCol: { xs: 16, sm: 18, md: 14, lg: 16, xl: 14 }
    };
  },
  computed: {
    // 计划信息展示字段列表
    fieldList() {
      const fieldList = [
        { label: '产品名称', key: 'productName' }
        // { label: '原保单计划', key: 'oldPlan' }
      ];
      return this.planCfg && this.planCfg.fieldList ? fieldList.concat(this.planCfg.fieldList) : fieldList;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.correct-plan {
  .plan-content {
  }
}
</style>
